import { AuthoServiceTypeComponent } from './autho-service-type/autho-service-type.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialModule } from '../../../../../core/material';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserGroupRoutingModule } from './user-group-routing.module';
import { UserGroupComponent } from './user-group.component';
import { AddUserGroupComponent } from './add-user-group/add-user-group.component';
import { UpdateUserGroupComponent } from './update-user-group/update-user-group.component';
import { AuthoUserGroupComponent } from './autho-user-group/autho-user-group.component';
import { WarningComponent } from '../../../../../shared/components/warning/warning.component';
import { TranslateModule } from '@ngx-translate/core';
import { NzAutocompleteModule, NzCheckboxModule, NzInputModule, NzSpinModule, NzTableModule, NzTabsModule, NzTagModule, NzTreeModule } from 'ng-zorro-antd';
import { PopupReloadPageComponent } from './popup-reload-page/popup-reload-page.component';
import {MatButtonToggleModule} from "@angular/material/button-toggle";

@NgModule({
  declarations: [
    UserGroupComponent,
    AddUserGroupComponent,
    UpdateUserGroupComponent,
    WarningComponent,
    AuthoUserGroupComponent,
    AuthoServiceTypeComponent,
    PopupReloadPageComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    UserGroupRoutingModule,
    MaterialModule,
    TranslateModule,
    SharedModule,
    NzTabsModule,
    NzTableModule,
    NzCheckboxModule,
    NzTagModule,
    NzTreeModule,
    MatButtonToggleModule,
    NzAutocompleteModule,
    NzInputModule,
    NzSpinModule
  ],
  entryComponents: [
    WarningComponent,
    UpdateUserGroupComponent,
    PopupReloadPageComponent
  ]
})
export class UserGroupModule { }
